module.exports = __webpack_public_path__ + "media/images/icons/success-2547c69cd520c0f8c2268b1e318e8c30.svg";